var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 24,
    viewBox: "0 0 13 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 1261158521"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.07387 24C4.46349 23.9983 2.91956 23.3579 1.78086 22.2191C0.642152 21.0804 0.00168512 19.5365 0 17.9261C0 17.8479 -2.21899e-07 17.7661 0.00545616 17.6688V17.6388C0.00545616 17.5951 0.00545616 17.5478 0.00545616 17.5087C0.0146379 16.3689 0.343343 15.2546 0.954218 14.2923C1.56509 13.33 2.43364 12.5584 3.46117 12.0651C3.40882 11.9655 3.37201 11.8584 3.35204 11.7477L3.19017 10.8683C3.16416 10.7216 3.16732 10.5713 3.19946 10.4259C3.23161 10.2804 3.29211 10.1428 3.3775 10.0207C3.4425 9.92782 3.52061 9.84481 3.6094 9.77429L3.54301 9.62242C3.41751 9.33505 3.27019 8.99039 3.16834 8.73849C3.10559 8.58844 3.05921 8.47658 3.04284 8.44202C2.77002 7.8491 2.54086 7.31801 2.33079 6.81693C1.87063 5.71929 1.4032 4.53616 1.10037 3.31666C1.02176 3.01839 0.967324 2.71427 0.937589 2.40726C0.917576 2.18281 0.945765 1.95667 1.02026 1.74399C1.09476 1.53132 1.21385 1.33702 1.36955 1.17412C2.35261 0.120125 4.81253 -0.0135564 6.18936 0.000993949C7.19606 0.0119067 8.26643 0.0437352 9.32224 0.301095C10.8837 0.682132 11.3384 1.47604 11.4448 2.07533C11.5812 2.84468 11.2911 3.57584 11.0346 4.22151C10.9655 4.39429 10.901 4.55799 10.8455 4.71622C10.2253 6.50592 9.45501 8.24378 8.75386 9.7461C8.92836 9.87048 9.06381 10.042 9.14434 10.2406C9.22487 10.4392 9.24714 10.6566 9.20856 10.8674C9.19492 10.9447 9.1831 11.0356 9.17127 11.132C9.12944 11.4612 9.08034 11.8523 8.87754 12.1624C9.50699 12.4921 10.0739 12.9295 10.5526 13.4546C11.5666 14.5677 12.1386 16.0619 12.165 17.6624C12.189 18.777 11.9217 19.8785 11.3893 20.858C10.8581 21.8032 10.087 22.5914 9.15366 23.1431C8.22035 23.6947 7.15798 23.9903 6.07387 24ZM4.47787 9.69881C4.5248 9.75349 4.55621 9.81975 4.56881 9.89069C4.57823 9.94361 4.5771 9.99786 4.56551 10.0503C4.55391 10.1028 4.53206 10.1525 4.50122 10.1965C4.47039 10.2405 4.43116 10.278 4.3858 10.3069C4.34044 10.3357 4.28983 10.3553 4.23688 10.3645C4.16237 10.3802 4.09704 10.4247 4.055 10.4882C4.00689 10.5556 3.98728 10.6392 4.00044 10.721L4.16232 11.5995C4.17635 11.6747 4.21783 11.7421 4.27872 11.7886C4.29527 11.8011 4.31293 11.8121 4.33146 11.8213L4.34783 11.8277C4.42464 11.8591 4.49009 11.9132 4.53548 11.9826C4.58088 12.0521 4.60408 12.1337 4.60201 12.2167C4.59994 12.2997 4.57269 12.38 4.52389 12.4472C4.47508 12.5143 4.40702 12.565 4.32873 12.5925C3.31163 12.9543 2.4302 13.6198 1.80368 14.4989C1.17716 15.378 0.835785 16.4283 0.825735 17.5078C0.825735 17.536 0.825735 17.5706 0.825735 17.6051V17.6551C0.826646 17.666 0.826646 17.677 0.825735 17.6879C0.825735 17.767 0.820279 17.8461 0.820279 17.9261C0.821963 19.3194 1.37619 20.6552 2.36141 21.6404C3.34662 22.6256 4.68238 23.1799 6.07569 23.1815C7.01413 23.1738 7.93391 22.9185 8.74206 22.4414C9.5502 21.9642 10.2181 21.2822 10.6781 20.4643C11.1416 19.6091 11.3733 18.6476 11.3502 17.6751C11.3275 16.2947 10.8182 14.9569 9.95154 14.0057C9.39605 13.3957 8.70476 12.9249 7.93359 12.6316C7.85035 12.5997 7.77976 12.5416 7.73252 12.466C7.68527 12.3904 7.66395 12.3015 7.67176 12.2127C7.67957 12.1239 7.71609 12.0401 7.77581 11.9739C7.83552 11.9077 7.91517 11.8628 8.0027 11.8459H8.02089C8.05902 11.8364 8.09488 11.8194 8.12638 11.7959L8.13365 11.7904C8.28279 11.6777 8.32826 11.3203 8.36464 11.0329C8.37828 10.9256 8.39101 10.8237 8.4092 10.7246C8.41985 10.6657 8.41314 10.6049 8.38989 10.5497C8.36665 10.4945 8.32786 10.4472 8.27824 10.4136L8.26642 10.4063C8.23368 10.3864 8.19765 10.3726 8.16002 10.3654L8.13456 10.3609C8.07304 10.3494 8.01496 10.324 7.96478 10.2867C7.91461 10.2493 7.87368 10.2009 7.84513 10.1452C7.81659 10.0895 7.8012 10.028 7.80013 9.96545C7.79907 9.90289 7.81237 9.84091 7.83901 9.7843C8.5738 8.21831 9.41408 6.36041 10.0752 4.45341C10.1361 4.27698 10.2071 4.09783 10.2762 3.92323C10.5035 3.35303 10.7373 2.76374 10.64 2.22356C10.549 1.69975 10.0388 1.32235 9.12945 1.10046C8.1573 0.864012 7.14059 0.834002 6.18208 0.827636C4.09047 0.80672 2.52085 1.14683 1.96703 1.73703C1.88836 1.81617 1.82829 1.91182 1.79117 2.01705C1.75405 2.12227 1.74081 2.23444 1.75241 2.34542C1.77892 2.6079 1.82605 2.86788 1.89337 3.12296C2.16619 4.22333 2.56723 5.27004 3.08468 6.5041C3.29202 6.99699 3.52118 7.52171 3.78764 8.10736C3.80401 8.14465 3.85494 8.26469 3.92223 8.42565C4.04955 8.72666 4.37875 9.51238 4.47787 9.69881ZM4.16413 9.5524C4.14094 9.55235 4.1178 9.55448 4.09502 9.55876C4.12074 9.55352 4.147 9.55139 4.17323 9.5524H4.16413Z",
    fill: "#474747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.08383 23.5908C9.21232 23.5908 11.7485 21.0546 11.7485 17.9261C11.7485 14.7976 9.21232 12.2615 6.08383 12.2615C2.95533 12.2615 0.419189 14.7976 0.419189 17.9261C0.419189 21.0546 2.95533 23.5908 6.08383 23.5908Z",
    fill: "#C24402"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.08383 23.5908C9.21232 23.5908 11.7485 21.0546 11.7485 17.9261C11.7485 14.7976 9.21232 12.2615 6.08383 12.2615C2.95533 12.2615 0.419189 14.7976 0.419189 17.9261C0.419189 21.0546 2.95533 23.5908 6.08383 23.5908Z",
    fill: "#C24402"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.66116 11.6732C8.62739 11.8574 8.52282 12.0211 8.36985 12.1292C8.21687 12.2373 8.02765 12.2812 7.8427 12.2516C6.76256 12.0673 5.659 12.0673 4.57887 12.2516C4.39392 12.2812 4.20469 12.2373 4.05172 12.1292C3.89874 12.0211 3.79417 11.8574 3.76041 11.6732L3.59945 10.7938C3.58239 10.7009 3.58384 10.6056 3.60369 10.5133C3.62355 10.421 3.66142 10.3335 3.71516 10.2559C3.76889 10.1782 3.83741 10.112 3.91681 10.0608C3.9962 10.0097 4.0849 9.97481 4.17783 9.95806C5.52272 9.73859 6.8943 9.73859 8.23919 9.95806C8.42663 9.99235 8.59281 10.0996 8.70125 10.2563C8.80968 10.413 8.85151 10.6063 8.81757 10.7938L8.66116 11.6732Z",
    fill: "url(#paint0_linear_28_1182)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.19741 0.411113C4.87242 0.396562 1.20391 0.525697 1.35487 2.3745C1.52583 4.49431 4.41863 10.4681 4.41863 10.4681H7.97529C7.97529 10.4681 10.869 4.49249 11.039 2.3745C11.1882 0.525697 7.52149 0.396562 6.19741 0.411113ZM5.90185 3.57945C5.6736 2.57912 5.95551 1.97528 6.23924 1.63789C6.48462 1.84884 6.66879 2.12187 6.77246 2.42841C6.87613 2.73494 6.89549 3.06371 6.82853 3.3803C6.78579 3.60674 6.58663 4.30152 6.32018 5.19091C6.11466 4.40337 5.95005 3.79316 5.90185 3.57945Z",
    fill: "url(#paint1_linear_28_1182)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.72,
    d: "M5.18808 3.05022C4.93981 2.76648 2.40441 2.28996 1.50684 3.21755C2.13796 5.75658 4.41691 10.4654 4.41691 10.4654H7.43884C7.30334 10.0944 5.4709 4.74806 5.20353 3.16298C5.19899 3.12479 5.19353 3.0875 5.18808 3.05022Z",
    fill: "url(#paint2_linear_28_1182)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    style: {
      mixBlendMode: "screen"
    },
    d: "M8.52101 0.564746C5.68914 0.439249 4.91524 1.4414 5.20625 3.16289C5.47361 4.74798 7.30605 10.0943 7.44155 10.4654H7.97627C7.97627 10.4654 10.87 4.48971 11.04 2.37172C11.1292 1.2668 9.84782 0.776635 8.52101 0.564746ZM10.3216 3.34477C10.0624 4.24508 9.26944 6.48674 7.69254 9.70056L6.32026 5.19358C6.11019 4.40331 5.95013 3.79311 5.90194 3.58213C5.67368 2.58179 5.95559 1.97795 6.23933 1.64056C7.02959 0.57384 9.18213 1.00398 9.90965 1.44231C10.1397 1.57872 10.7099 1.94248 10.3216 3.34477Z",
    fill: "url(#paint3_linear_28_1182)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_8",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.48
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90959 1.4424C9.18207 1.00589 7.02952 0.573925 6.23926 1.64065C6.48464 1.8516 6.6688 2.12463 6.77247 2.43117C6.87615 2.7377 6.89551 3.06647 6.82855 3.38305C6.7858 3.60949 6.58665 4.30427 6.3202 5.19367L7.69247 9.70064C9.26937 6.48683 10.0624 4.24425 10.3215 3.34486C10.7099 1.94257 10.1397 1.57881 9.90959 1.4424Z",
    fill: "#392C82"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M8.66116 11.6732C8.62739 11.8574 8.52282 12.0211 8.36985 12.1292C8.21687 12.2373 8.02765 12.2812 7.8427 12.2516C6.76256 12.0673 5.659 12.0673 4.57887 12.2516C4.39392 12.2812 4.20469 12.2373 4.05172 12.1292C3.89874 12.0211 3.79417 11.8574 3.76041 11.6732L3.59945 10.7938C3.58239 10.7009 3.58384 10.6056 3.60369 10.5133C3.62355 10.421 3.66142 10.3335 3.71516 10.2559C3.76889 10.1782 3.83741 10.112 3.91681 10.0608C3.9962 10.0097 4.0849 9.97481 4.17783 9.95806C5.52272 9.73859 6.8943 9.73859 8.23919 9.95806C8.42663 9.99235 8.59281 10.0996 8.70125 10.2563C8.80968 10.413 8.85151 10.6063 8.81757 10.7938L8.66116 11.6732Z",
    fill: "url(#paint4_linear_28_1182)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_10",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.69
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24281 9.95894C7.57162 9.84806 6.8924 9.793 6.21212 9.79434C5.71713 9.79491 5.22256 9.82315 4.73071 9.87891C6.84233 9.87891 8.11549 10.3591 8.29737 10.6137C8.47925 10.8683 8.29737 11.7368 8.13913 11.8423C8.03728 11.9105 8.06729 12.1151 8.10094 12.2452C8.24074 12.2166 8.3688 12.1469 8.46864 12.0449C8.56847 11.943 8.63551 11.8135 8.66113 11.6732L8.823 10.7938C8.85664 10.6061 8.81443 10.4128 8.70564 10.2563C8.59686 10.0998 8.43039 9.99281 8.24281 9.95894Z",
    fill: "#FEDF12"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M7.99831 11.7031C6.82987 11.3309 5.57463 11.3309 4.40619 11.7031C4.25523 11.7559 4.12701 11.9059 4.03516 12.1142C4.11199 12.173 4.19998 12.2156 4.29378 12.2394C4.38758 12.2631 4.48523 12.2676 4.58079 12.2524C5.66093 12.0681 6.76449 12.0681 7.84462 12.2524C7.93703 12.2673 8.03145 12.2637 8.12245 12.2418C8.21345 12.22 8.29922 12.1803 8.3748 12.1251C8.28204 11.9123 8.152 11.7568 7.99831 11.7031Z",
    fill: "#C24402"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M6.08389 23.127C9.21188 23.127 11.7476 20.61 11.7476 17.5051C11.7476 14.4002 9.21188 11.8832 6.08389 11.8832C2.9559 11.8832 0.420166 14.4002 0.420166 17.5051C0.420166 20.61 2.9559 23.127 6.08389 23.127Z",
    fill: "url(#paint5_linear_28_1182)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_13",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.69
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47843 11.8986C5.27985 14.0156 5.28985 16.3255 6.65031 17.4786C7.90346 18.5417 9.93596 18.3135 11.7293 17.0767C11.6166 15.7288 11.0252 14.4657 10.0621 13.5159C9.09899 12.5662 7.82779 11.9925 6.47843 11.8986Z",
    fill: "#FEDF12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_14",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.69
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84547 21.5311C7.7751 21.5311 9.33938 19.9029 9.33938 17.8944C9.33938 15.8859 7.7751 14.2577 5.84547 14.2577C3.91584 14.2577 2.35156 15.8859 2.35156 17.8944C2.35156 19.9029 3.91584 21.5311 5.84547 21.5311Z",
    fill: "#FEDF12"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M6.08395 21.1845C8.09243 21.1845 9.72063 19.5563 9.72063 17.5478C9.72063 15.5393 8.09243 13.9111 6.08395 13.9111C4.07546 13.9111 2.44727 15.5393 2.44727 17.5478C2.44727 19.5563 4.07546 21.1845 6.08395 21.1845Z",
    fill: "url(#paint6_radial_28_1182)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_16",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08395 21.1845C8.09243 21.1845 9.72063 19.5563 9.72063 17.5478C9.72063 15.5393 8.09243 13.9111 6.08395 13.9111C4.07546 13.9111 2.44727 15.5393 2.44727 17.5478C2.44727 19.5563 4.07546 21.1845 6.08395 21.1845Z",
    fill: "#AE21C4"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M6.08472 14.3649C7.00977 14.3654 7.89988 14.7183 8.57395 15.3519C9.24802 15.9854 9.6554 16.8519 9.71322 17.7752C9.71322 17.6997 9.72049 17.6242 9.72049 17.5487C9.72049 16.584 9.33725 15.6587 8.65507 14.9766C7.97289 14.2944 7.04765 13.9111 6.0829 13.9111C5.11815 13.9111 4.19292 14.2944 3.51074 14.9766C2.82855 15.6587 2.44531 16.584 2.44531 17.5487C2.44531 17.6242 2.44531 17.6997 2.45258 17.7752C2.51044 16.8513 2.91833 15.9842 3.59318 15.3506C4.26802 14.717 5.15904 14.3645 6.08472 14.3649Z",
    fill: "#C24402"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M8.562 13.0663C8.69204 12.8681 8.99488 12.9508 9.30407 13.1573C9.61327 13.3637 9.81061 13.6047 9.68056 13.803C9.55052 14.0012 9.24041 13.9284 8.93122 13.7257C8.62202 13.5229 8.43196 13.2646 8.562 13.0663Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M2.84101 19.8051C2.98197 19.6568 3.21205 19.7578 3.42484 19.9588C3.63764 20.1597 3.75314 20.3835 3.61218 20.5326C3.47122 20.6817 3.23478 20.5872 3.02198 20.3862C2.80918 20.1852 2.69824 19.9542 2.84101 19.8051Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M3.78124 20.6317C3.904 20.4762 4.05951 20.4962 4.18955 20.5981C4.3196 20.6999 4.37143 20.8481 4.25048 21.0027C4.20059 21.0629 4.12916 21.1011 4.05147 21.1092C3.97377 21.1174 3.89597 21.0948 3.83469 21.0463C3.77341 20.9979 3.73352 20.9274 3.72353 20.8499C3.71354 20.7724 3.73425 20.6941 3.78124 20.6317Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M7.85993 10.278C7.92995 10.1716 8.09274 10.2162 8.25916 10.3253C8.42558 10.4345 8.53197 10.5654 8.46104 10.6718C8.39011 10.7782 8.2246 10.7391 8.05818 10.63C7.89176 10.5208 7.79082 10.3844 7.85993 10.278Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M6.65218 0.727661C6.34103 0.816428 6.05282 0.971552 5.80735 1.18236C5.57805 1.39598 5.41354 1.66986 5.33265 1.97263C5.2529 2.28302 5.22222 2.60398 5.24171 2.92386C5.25717 3.24851 5.30537 3.57317 5.35356 3.90328C5.22295 3.596 5.13218 3.27327 5.08347 2.94295C5.0314 2.60302 5.04779 2.25612 5.13167 1.92261C5.15895 1.83985 5.18623 1.75619 5.22261 1.67616L5.28172 1.55794C5.29982 1.51774 5.32175 1.47936 5.3472 1.44336C5.39435 1.36919 5.44856 1.29975 5.50907 1.23601C5.53908 1.20419 5.56818 1.17145 5.60001 1.14508L5.70277 1.06414C5.97795 0.857531 6.31008 0.740683 6.654 0.72948C6.654 0.72948 6.65309 0.727661 6.65218 0.727661Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M6.71945 19.9022H5.52722V17.053L4.90247 17.1676V16.4019C5.04252 16.3568 5.17952 16.3028 5.31261 16.24C5.49393 16.1549 5.6706 16.0602 5.84188 15.9563H6.72399L6.71945 19.9022Z",
    fill: "#C24402"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M6.71945 19.5384H5.52722V16.6893L4.90247 16.8038V16.0381C5.04252 15.9931 5.17952 15.939 5.31261 15.8763C5.49393 15.7911 5.6706 15.6964 5.84188 15.5925H6.72399L6.71945 19.5384Z",
    fill: "url(#paint7_linear_28_1182)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_1182",
    x1: 5.24273,
    y1: 12.3307,
    x2: 7.06153,
    y2: 9.82074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE815"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28_1182",
    x1: 6.19741,
    y1: 10.0389,
    x2: 6.19741,
    y2: 1.49602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4681E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57BBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_28_1182",
    x1: 3.59299,
    y1: 2.72192,
    x2: 5.2672,
    y2: 10.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4681E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57BBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_28_1182",
    x1: 5.14805,
    y1: 5.51005,
    x2: 11.0437,
    y2: 5.51005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4681E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57BBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_28_1182",
    x1: 5.24091,
    y1: 12.3307,
    x2: 7.06425,
    y2: 9.82074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE815"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_28_1182",
    x1: 7.85449,
    y1: 13.7702,
    x2: 4.09777,
    y2: 21.6947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_28_1182",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.67046 17.4188) scale(6.23011 6.2301)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFE815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FEE113"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FABE09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F7A802"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F6A000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_28_1182",
    x1: 6.66215,
    y1: 15.5707,
    x2: 5.18893,
    y2: 19.4084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldMedal);
export default __webpack_public_path__ + "static/media/goldMedal.35d07132fdb2cc5323cd0d3e835ea68f.svg";
export { ForwardRef as ReactComponent };